import { useEffect } from "react";
import { useGetCarcinogenicReportQuery } from "../../../services/carcinogenicApi";
import { useDispatch } from "react-redux";
import { setCarcinogenicReportData } from "../../../redux/slices/carcinogenicReportSlice";

const useCarcinogenicReportPrecharge = (carcinogenicReportId: number | null) => {
    const dispatch = useDispatch();
    const {
        data: carcinogeniReportInitialData,
        isSuccess: carcinogenicReportDataSuccess,
        isFetching: isFetchingCarcinogenicReportInitialData
    } = useGetCarcinogenicReportQuery(carcinogenicReportId, { skip: !carcinogenicReportId });

    useEffect(() => {
        if(carcinogenicReportDataSuccess && carcinogeniReportInitialData?.data) {
            dispatch(setCarcinogenicReportData(carcinogeniReportInitialData?.data));
        }
    }, [carcinogeniReportInitialData]);
    return { carcinogeniReportInitialData, isFetchingCarcinogenicReportInitialData, carcinogenicReportDataSuccess };
};

export default useCarcinogenicReportPrecharge;
